(function () {
  if (window.OnePillowReviewWallLoaded) return;
  window.OnePillowReviewWallLoaded = true;

  var apiBase = 'https://dashboard.webwinkelkeur.nl/api/1.0/';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktopMedia = window.matchMedia('(min-width: 990px)');

  function toNumber(value) {
    if (value == null) return 0;
    return parseFloat(String(value).replace(',', '.')) || 0;
  }

  function formatDecimal(value) {
    var number = Math.round(value * 10) / 10;
    return String(number).replace('.', ',');
  }

  function scoreToTen(value) {
    var score = toNumber(value);
    return score > 0 && score <= 5 ? score * 2 : score;
  }

  function scoreToStars(value) {
    var score = toNumber(value);
    if (score > 5) score = score / 2;
    return Math.max(1, Math.min(5, Math.round(score || 5)));
  }

  function firstText() {
    for (var i = 0; i < arguments.length; i += 1) {
      var value = arguments[i];
      if (typeof value === 'string' && value.trim()) return value.trim();
    }
    return '';
  }

  function deriveTitle(text) {
    var clean = firstText(text);
    if (!clean) return 'Fijne ervaring';
    var sentence = clean.split(/[.!?]/)[0].trim();
    if (sentence.length <= 48) return sentence;
    var words = sentence.split(/\s+/);
    var title = '';

    for (var i = 0; i < words.length; i += 1) {
      var next = title ? title + ' ' + words[i] : words[i];
      if (next.length > 48) break;
      title = next;
    }

    return title || sentence;
  }

  function normalizeItems(payload, minScore, limit) {
    var source = payload && (payload.ratings || payload.reviews || payload.items || payload.data || payload.response || payload);
    var items = Array.isArray(source) ? source : [];

    return items
      .map(function (item) {
        var text = firstText(item.review, item.message, item.comment, item.text, item.content, item.description);
        var rating = toNumber(item.rating || item.score || item.stars || item.rate);
        var score10 = scoreToTen(rating);

        return {
          id: item.id || item.rating_id || text,
          title: firstText(item.title, item.subject, deriveTitle(text)),
          text: text,
          author: firstText(item.name, item.author, item.customer_name, item.consumer && item.consumer.displayName, 'Klant'),
          date: firstText(item.date, item.created_at, item.createdAt, item.created, item.rating_date, 'recent'),
          stars: scoreToStars(rating),
          score10: score10 || 10
        };
      })
      .filter(function (item) {
        return item.text && item.score10 >= minScore;
      })
      .slice(0, limit);
  }

  function normalizeSummary(payload) {
    var data = payload && (payload.summary || payload.data || payload.response || payload);
    if (!data || typeof data !== 'object') return null;

    var score = data.rating_average || data.average || data.average_rating || data.rating || data.score || data.total_score || data.shop_rating;
    var count = data.amount || data.count || data.review_count || data.reviews || data.total || data.total_reviews || data.ratings_count;

    return {
      score: score ? formatDecimal(scoreToTen(score)) : '',
      count: toNumber(count)
    };
  }

  function buildUrl(path, section, limit) {
    var publicCode = section.getAttribute('data-webwinkelkeur-public-code');
    if (!publicCode) return '';

    var params = new URLSearchParams();
    params.set('public_code', publicCode);

    var shopId = section.getAttribute('data-webwinkelkeur-shop-id');
    if (shopId) params.set('id', shopId);

    var language = section.getAttribute('data-language');
    if (language) params.set('language', language);

    if (limit) {
      params.set('limit', String(limit));
      params.set('offset', '0');
    }

    return apiBase + path + '?' + params.toString();
  }

  function fetchJson(url) {
    return fetch(url, { credentials: 'omit' }).then(function (response) {
      if (!response.ok) throw new Error('Review API response was not ok');
      return response.json();
    });
  }

  function renderStars(count) {
    var html = '';
    for (var i = 1; i <= 5; i += 1) {
      html += '<span aria-hidden="true">' + (i <= count ? '&#9733;' : '&#9734;') + '</span>';
    }
    return html;
  }

  function createCard(review) {
    var card = document.createElement('article');
    card.className = 'op-review-wall-native__card';
    card.setAttribute('data-op-review-card', '');
    card.setAttribute('role', 'listitem');

    var top = document.createElement('div');
    top.className = 'op-review-wall-native__card-top';

    var quote = document.createElement('span');
    quote.className = 'op-review-wall-native__quote';
    quote.setAttribute('aria-hidden', 'true');
    quote.innerHTML = '&ldquo;';

    var stars = document.createElement('span');
    stars.className = 'op-review-wall-native__stars';
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', review.stars + ' van 5 sterren');
    stars.innerHTML = renderStars(review.stars);

    top.appendChild(quote);
    top.appendChild(stars);

    var title = document.createElement('h3');
    title.textContent = review.title;

    var text = document.createElement('p');
    text.textContent = review.text;

    var footer = document.createElement('footer');
    var reviewer = document.createElement('div');
    reviewer.className = 'op-review-wall-native__reviewer';
    var author = document.createElement('strong');
    author.textContent = review.author;
    var verified = document.createElement('span');
    verified.className = 'op-review-wall-native__verified';
    verified.textContent = 'Geverifieerd';
    var date = document.createElement('span');
    date.className = 'op-review-wall-native__date';
    date.textContent = formatRelativeDate(review.date);
    reviewer.appendChild(author);
    reviewer.appendChild(verified);
    footer.appendChild(reviewer);
    footer.appendChild(date);

    card.appendChild(top);
    card.appendChild(title);
    card.appendChild(text);
    card.appendChild(footer);

    return card;
  }

  function renderReviews(section, reviews) {
    var left = section.querySelector('[data-op-review-column="left"]');
    var right = section.querySelector('[data-op-review-column="right"]');
    var mobile = section.querySelector('[data-op-review-mobile]');
    if (!left || !right || !mobile || !reviews.length) return;

    left.innerHTML = '';
    right.innerHTML = '';
    mobile.innerHTML = '';

    var splitIndex = Math.ceil(reviews.length / 2);

    reviews.forEach(function (review, index) {
      (index < splitIndex ? left : right).appendChild(createCard(review));
      mobile.appendChild(createCard(review));
    });

    setupMobileIndicator(section);
  }

  function updatePlatformStars(root, scoreFive) {
    if (!root) return;

    Array.prototype.slice.call(root.querySelectorAll('[data-op-review-platform-star]')).forEach(function (star, index) {
      var fill = Math.max(0, Math.min(100, (scoreFive - index) * 100));
      star.style.setProperty('--op-star-fill', fill + '%');
    });
  }

  function renderSummary(section, summary) {
    if (!summary) return;

    var score = section.querySelector('[data-op-review-score]');
    var scoreStars = section.querySelector('[data-op-review-platform-stars]');
    var count = section.querySelector('[data-op-review-count]');
    var bolCount = toNumber(section.getAttribute('data-bol-review-count'));
    var totalCount = summary.count + bolCount;

    if (score && summary.score) score.textContent = summary.score + '/10';
    if (scoreStars && summary.score) updatePlatformStars(scoreStars, toNumber(summary.score) / 2);
    if (count && totalCount > 0) count.innerHTML = 'Gebaseerd op <strong>' + totalCount + '</strong> reviews';
  }

  function formatRelativeDate(value) {
    if (!value || value === 'recent') return 'recent';

    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    var today = new Date();
    var diff = today.setHours(0, 0, 0, 0) - date.setHours(0, 0, 0, 0);
    var days = Math.max(0, Math.round(diff / 86400000));

    if (days === 0) return 'vandaag';
    if (days === 1) return '1 dag geleden';
    if (days < 31) return days + ' dagen geleden';
    return date.toLocaleDateString('nl-NL');
  }

  function setupMotion(section) {
    var left = section.querySelector('[data-op-review-column="left"]');
    var right = section.querySelector('[data-op-review-column="right"]');
    if (!left || !right) return;

    var ticking = false;

    function update() {
      ticking = false;

      if (!desktopMedia.matches || reducedMotion.matches) {
        left.style.transform = '';
        right.style.transform = '';
        return;
      }

      var rect = section.getBoundingClientRect();
      var range = window.innerHeight + rect.height;
      var progress = Math.min(1, Math.max(0, (window.innerHeight - rect.top) / range));
      var shift = (progress - 0.5) * 190;

      left.style.transform = 'translate3d(0,' + (-shift) + 'px,0)';
      right.style.transform = 'translate3d(0,' + shift + 'px,0)';
    }

    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  }

  function setupMobileIndicator(section) {
    var rail = section.querySelector('[data-op-review-mobile]');
    var indicator = section.querySelector('[data-op-review-mobile-indicator]');
    if (!rail || !indicator) return;

    var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-op-review-card]'));
    if (!cards.length) {
      indicator.innerHTML = '';
      indicator.hidden = true;
      return;
    }

    if (section._opReviewWallScrollHandler) {
      rail.removeEventListener('scroll', section._opReviewWallScrollHandler);
    }

    indicator.hidden = false;
    indicator.innerHTML = '';

    cards.forEach(function (card, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'op-review-wall-native__dot';
      button.setAttribute('aria-label', 'Ga naar review ' + (index + 1) + ' van ' + cards.length);
      button.addEventListener('click', function () {
        rail.scrollTo({
          left: card.offsetLeft - rail.offsetLeft,
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        });
      });
      indicator.appendChild(button);
    });

    var dots = Array.prototype.slice.call(indicator.querySelectorAll('.op-review-wall-native__dot'));

    function updateActiveDot() {
      var railCenter = rail.scrollLeft + rail.clientWidth / 2;
      var activeIndex = 0;
      var activeDistance = Infinity;

      cards.forEach(function (card, index) {
        var cardCenter = card.offsetLeft + card.offsetWidth / 2;
        var distance = Math.abs(cardCenter - railCenter);
        if (distance < activeDistance) {
          activeDistance = distance;
          activeIndex = index;
        }
      });

      dots.forEach(function (dot, index) {
        var isActive = index === activeIndex;
        dot.classList.toggle('is-active', isActive);
        if (isActive) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    var ticking = false;
    section._opReviewWallScrollHandler = function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          updateActiveDot();
        });
      }
    };

    rail.addEventListener('scroll', section._opReviewWallScrollHandler, { passive: true });
    window.setTimeout(updateActiveDot, 0);
  }

  function initSection(section) {
    if (!section || section.dataset.opReviewWallReady === 'true') return;
    section.dataset.opReviewWallReady = 'true';

    var hasReviewWall = section.hasAttribute('data-op-review-wall');

    if (hasReviewWall) {
      setupMotion(section);
      setupMobileIndicator(section);
    }

    var limit = Math.max(4, toNumber(section.getAttribute('data-review-limit')) || 11);
    var fetchLimit = Math.min(36, Math.max(limit, limit * 3));
    var minScore = toNumber(section.getAttribute('data-min-score')) || 8;
    var summaryUrl = buildUrl('ratings_summary.json', section);

    if (!summaryUrl) return;

    if (!hasReviewWall) {
      fetchJson(summaryUrl).then(function (payload) {
        renderSummary(section, normalizeSummary(payload));
      }).catch(function () {});
      return;
    }

    var reviewsUrl = buildUrl('ratings.json', section, fetchLimit);
    if (!reviewsUrl) return;

    Promise.allSettled([fetchJson(summaryUrl), fetchJson(reviewsUrl)]).then(function (results) {
      if (results[0].status === 'fulfilled') {
        renderSummary(section, normalizeSummary(results[0].value));
      }

      if (results[1].status === 'fulfilled') {
        var reviews = normalizeItems(results[1].value, minScore, limit);
        if (reviews.length) renderReviews(section, reviews);
      }
    });
  }

  function initAll(root) {
    var scope = root || document;

    if (scope.nodeType === 1 && scope.matches('[data-op-review-wall], [data-op-review-summary]')) {
      initSection(scope);
    }

    scope.querySelectorAll('[data-op-review-wall], [data-op-review-summary]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.slice.call(mutation.addedNodes || []).forEach(function (node) {
          if (node && node.nodeType === 1) initAll(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
